import type { CTAButtonProps } from '@components/CallToActionButton';
import type { ProductListItem } from '@providers/ProductListProvider/types';
import { useProductItemThemeSettings } from '@providers/ThemeProvider/Provider/ProductItemThemeSettings';
import type { CTAButtonType } from '@providers/ThemeProvider/types';
import { useMemo } from 'react';

export type CTAButtonPropsMapSettings = CTAButtonProps & {
  action?: 'popup' | 'quickAddToCart' | 'productPage';
  displayType?: 'textWithIcon' | 'text' | 'icon';
};

export type ProductCTAPropsMapSettings = {
  qvBtn?: CTAButtonPropsMapSettings;
  selectOptionBtn?: CTAButtonPropsMapSettings;
  goToDetailBtn?: CTAButtonPropsMapSettings;
};

export const useConnectCTAButton = (place: 'img' | 'info', product: ProductListItem) => {
  const settings = useProductItemThemeSettings();
  const productElmSettings =
    place === 'img' ? settings.productImg.elements : settings.productInfo?.elements;

  const props: ProductCTAPropsMapSettings = useMemo(() => {
    const productCTAProps: ProductCTAPropsMapSettings = {};
    if (productElmSettings) {
      // Maximum 2 btn
      ['qvBtn', 'selectOptionBtn', 'goToDetailBtn'].forEach((item) => {
        const ctasSettings = productElmSettings[item as CTAButtonType];
        if (ctasSettings) {
          productCTAProps[item as CTAButtonType] = {
            ...ctasSettings,
            iconImageSrc: ctasSettings.displayType !== 'text' ? ctasSettings.imgSrc : undefined,
            showButtonOnHover: ctasSettings.showOnHovering,
            hideOnMobile: ctasSettings.showOn === 'desktopOnly',
            position: ctasSettings.alignment,
          };
        }
      });
    }
    return productCTAProps;
  }, [productElmSettings]);

  return {
    props,
  };
};
